__turbopack_context__.v({
  "back_button": "XnC1ga_back_button",
  "expat_btn": "XnC1ga_expat_btn",
  "icon_btn": "XnC1ga_icon_btn",
});
